export default __webpack_public_path__ + "static/media/town-back.11880005.png";